// index.js
import React, { useCallback } from "react";
import "./service.css";
import { services } from "../../constants/mockData";
import Header from "../../components/Header/header";
import Footer from "../../components/Footer/footer";
import { useNavigate } from "react-router-dom";

const ServicePage = () => {
  const navigate = useNavigate();
  const onBtnPress = useCallback(() => {
    navigate("/contact-form");
  }, [navigate]);

  return (
    <>
      <Header />
      <div className="services-container">
        <h2 className="title">Services We Offer</h2>
        <p className="subtitle">
          Transforming Ideas into Exceptional Digital Solutions
        </p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div>
                <p className="service-page-card-title">{service.title}</p>
                <p className="service-page-card-description">
                  {service.description}
                </p>
                <div className="service-page-heading-container">
                  <span className="service-page-green-line"></span>
                  <h4 className="service-page-gray-text-style">
                    What we Offer
                  </h4>
                </div>
                <ul>
                  {service.offerings.map((offer, idx) => (
                    <li key={idx} className="service-light-list-text-style">
                      {offer}
                    </li>
                  ))}
                </ul>
                <div className="service-page-heading-container">
                  <span className="service-page-green-line"></span>
                  <h4 className="service-page-gray-text-style">
                    Why Choose Us
                  </h4>
                </div>
                <ul>
                  {service.whyChooseUs.map((reason, idx) => (
                    <li key={idx} className="service-light-list-text-style">
                      {reason}
                    </li>
                  ))}
                </ul>
              </div>

              <button className="contact-btn-style" onClick={onBtnPress}>
                <span className="connect-btn-text-style">Let's Connect</span>
              </button>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ServicePage;
